import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Users } from "lucide-react";
import UserRegistrationForm from "./UserRegistrationForm";
import "../../GisincidentManagement/ViewIncident/ViewIncident.css";

const CreateUser = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const edit = state?.edit;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="incv-header-banner">
        <button type="button" className="incv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="incv-header-icon">
          <Users size={14} color="#fff" />
        </span>
        <div>
          <div className="incv-header-title">{edit ? "Edit User Details" : t("createuser_management_formheader")}</div>
          <div className="incv-header-subtitle">{edit ? "Update user account details" : "Register a new system user"}</div>
        </div>
      </div>
      <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px", padding: "20px 16px" }}>
        <UserRegistrationForm />
      </div>
    </div>
  );
};

export default CreateUser;
